let md = `
### 一、基础前提

1. 规则：总的收益不变，A和B默认平均分配
2. 规则：因为收益不变，所以A和B的收益是此消彼长状态
3. 动机：A和B工作都是以收益作为第一追求目标

基于以上前提，A与B的决策状态如下：
|#|A卷|A不卷|
|--|--|--|
|B卷|${state('AB', 130, 100, 130, 100)}|${state('aB', 100, 80, 130, 120)}|
|B不卷|${state('Ab', 130, 120, 100, 80)}|${state('ab', 100, 100, 100, 100)}|

在这个囚徒困境里，状态最终会从ab演进到AB，但是AB就是一个稳定的结束状态吗？

<!-- read more -->

> 答案：这取决于130是不是A和B的极限。如果，A的投入极限是180，B的投入极限是150，那这个AB态还会继续演进。

在基础前提下，卷是一个必然的演进方向，因为无论你是主动卷还是被动卷，更卷会让你获得更多收益：
1. 如果你是主动卷，你会比不卷的人多获得20个收益
2. 如果你是被动卷，你可以避免自己应有的20个收益被别人卷走

### 二、为什么大部分人不接受卷？
> 答案：很显然，最终同样是100的收益，大家都投入了更多，A和B的投入回报率都下降了

我们把ROI的计算加上，A与B的决策状态更新如下：
|#|A卷|A不卷|
|--|--|--|
|B卷|${state('AB', 130, 100, 130, 100, true)}|${state('aB', 100, 80, 130, 120, true)}|
|B不卷|${state('Ab', 130, 120, 100, 80, true)}|${state('ab', 100, 100, 100, 100, true)}|

在囚徒困境中，唯一的解法只有一个：
> A和B达成利益联盟，相互信任对方不会为了利益出卖自己

但这个是理论上的解法，现实中这个共识的达成十分困难，关键在于每个人对于蛋糕的分法都有一套自己的看法。

> 备注：以上内容也可以用“边际成本”的原理来进行解释

### 三、困局不是你想逃就能逃

在上一节中讲到，困局之中的A和B是有理论解的：相互信任。但这个也仅仅是理论解而已。

实际上，困局之中并非只有A和B，还存在一个掌控者C。

在囚徒困境的故事中，除了两个囚犯，还有警察。囚犯的诉求是为自己脱罪，而警察是为了证据与真相，可以看到囚犯与警察的动机并不一致。

A和B在困境之中是最求个人收益最大化，而掌控者C更关心的是整体的**产出**。对于C来说，给A和B的蛋糕是不变的，所以成本是不变的，无论A和B的个人效率高还是低，只要最终对C的产出在增长，这个囚徒困境就是合适的。

如果把C的关注点加上，那上面的表转换为下面的样子：
|#|A卷|A不卷|
|--|--|--|
|B卷|${state('AB', 130, 100, 130, 100, true, true)}|${state('aB', 100, 80, 130, 120, true, true)}|
|B不卷|${state('Ab', 130, 120, 100, 80, true, true)}|${state('ab', 100, 100, 100, 100, true, true)}|

从C的视角来看，整体的走势是“稳中向好”符合预期。

所以，A和B不要再天真地跟C讨论个人效率下降的问题，因为这不是C所关心的。

### 四、问题

所以，你自己的角色是什么？
1. 主动开卷的A
2. 被动应对的B
3. 分蛋糕的C

`

function state(name, ia, oa, ib, ob, roi=false, showC=false) {
  let percent = n => (n*100).toFixed(0) + '%'
  let title = `**状态：${name}**`
  let aDesc = 'A：' + [`投入${ia}`, `收益${oa}`, roi?`ROI=${percent(oa/ia)}`:''].filter(d=>!!d).join('，')
  let bDesc = 'B：' + [`投入${ib}`, `收益${ob}`, roi?`ROI=${percent(ob/ib)}`:''].filter(d=>!!d).join('，')
  let cDesc = showC ? `C：产出=${ia+ib}` : ''
  return [title, aDesc, bDesc, cDesc].filter(d => !!d).join('<br/>')
}

module.exports = {
  title: '人在卷途，身不由己',
  author: 'gzshi',
  post: '2023-02-25 12:00',
  tags: ['博弈', '管理', '胡思乱想'],
  summary: md,
  summaryCompiler: 'md',
  more: false
}


// WEBPACK FOOTER //
// ./src/blog/20230227_roll_to_death/data.js